import CommunicationIcon from '@/CustomIcons/CommunicationIcon'
import MenuButton from '@/UIComponents2/MenuButton/MenuButton'
import { useTranslation } from 'react-i18next'
import { chatTrigger } from '../sidebar/Sidebar'
import { Badge } from '@/UIComponents2/Badge'
import useChatRoomController from '@/pages/ChatRoom/useChatRoomController'

type ChatMenuButtonProps = {
    labelPosition?: 'inside' | 'outside'
    triggerClassName?: string
    chatController?: ReturnType<typeof useChatRoomController>
}
export function ChatMenuButton(props: ChatMenuButtonProps) {
    const { t } = useTranslation()

    return (
        <MenuButton
            icon={
                <div className="relative">
                    <div className="flex items-center justify-center">
                        <CommunicationIcon style={{ fontSize: '1.3rem' }} />
                    </div>
                    {props.chatController && props.chatController.unreadMessagesCt > 0 && (
                        <Badge className="top-[-6px] right-[-6px]">{props.chatController.unreadMessagesCt}</Badge>
                    )}
                </div>
            }
            label={t('Chat')}
            labelPosition={props.labelPosition}
            triggerClassName={props.triggerClassName}
            onIconClick={() => {
                chatTrigger.trigger(true)
            }}
        />
    )
}
